// extracted by mini-css-extract-plugin
export var _row = "_row__QDFQ";
export var banner = "banner__RVHS";
export var bannerButtons = "bannerButtons__lih_";
export var bannerInfo = "bannerInfo__FHNj";
export var bannerSecondaryText = "bannerSecondaryText___PPp";
export var closeButton = "closeButton__qYRA";
export var image = "image__XnR1";
export var imageContainer = "imageContainer___dPo";
export var mainText = "mainText__flZF";
export var text = "text__LkFw";
export var textContainer = "textContainer__AvtJ";
export var tryButton = "tryButton__oVJF";